import React, { useContext } from 'react';
import ColorsContext from './ColorsContext';

export default function ResvTable(props) {
  const { regionData, monyr } = props;
  const { levelColors } = useContext(ColorsContext);
  
  let droughtRegions = [
    "Western",
    "Connecticut River",
    "Central",
    "Northeast",
    "Southeast",
    "Cape Cod"
  ];

  if (regionData['Islands']) {
    droughtRegions.push("Islands");
  };

  return (
    <>
      <table className="pcpnTable-container">
        <caption>
          {monyr} {monyr.search(",") < 0 ? "Monthly" : "30-Day"} Lakes and Impoundments Summary
        </caption>
        <thead>
        <tr>
          <td colSpan="3">
              <table className="tableLegend-container">
                  <tbody>
                      <tr>
                          <td className="tableLegend-heading" colSpan="5">Shading indicates index severity level:</td>
                      </tr>
                      <tr>
                          <td className="tableLegend-value-container" style={{"backgroundColor":levelColors[0]}}>Level 0</td>
                          <td className="tableLegend-value-container" style={{"backgroundColor":levelColors[1]}}>Level 1</td>
                          <td className="tableLegend-value-container" style={{"backgroundColor":levelColors[2]}}>Level 2</td>
                          <td className="tableLegend-value-container" style={{"backgroundColor":levelColors[3]}}>Level 3</td>
                          <td className="tableLegend-value-container" style={{"backgroundColor":levelColors[4], "color":"white"}}>Level 4</td>
                      </tr>
                  </tbody>
              </table>
          </td>
      </tr>
          <tr>
            <th scope="col">Region</th>
            <th scope="col">{"Number of sites reporting"}</th>
            <th scope="col" abbr="Percentile">{"Median of individual percentiles or percent full"}</th>
          </tr>
        </thead>
        <tbody>
          {droughtRegions.map((rd, i) => (
              <tr key={i}>
                <th scope="row">{rd.replace("Connecticut River","CTRV")}</th>
                <td>{regionData.hasOwnProperty(rd) ? regionData[rd].count : 0}</td>
                <td 
                  style={{
                    backgroundColor: regionData.hasOwnProperty(rd) ? levelColors[regionData[rd].level] : "lightgray", 
                    color: regionData.hasOwnProperty(rd) ? (regionData[rd].level !== 4 ? "black" : "white") : "black"
                  }}
                >
                  {regionData.hasOwnProperty(rd) ? regionData[rd].percentile : "-"}
                </td>
              </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}